module.exports = __webpack_public_path__ + "img/fashion_03.1fcc53d8.jpg";